<div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-change-pwd-main-div">
    <div class="orgApp-d-flex orgApp-margin-left-36 orgApp-reset-pwd-hd">
        <svg matPrefix width="24" height="24" class="orgApp-margin-top-38" fill="none" (click)="showLogin('back')">
            <use xlink:href="#back-arrow"></use>
        </svg>
        <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-align-i-center orgApp-margin-left-34">
            <h2 mat-dialog-title class="orgApp-dialog-heading orgApp-change-pwd-title orgApp-d-flex orgApp-align-i-center">
                <b> {{ "reset_pwd.title" | translate }}</b>
            </h2>
            <p class="orgApp-reset-pwd-heading orgApp-reset-pwd-font">
                        {{ "reset_pwd.desc" | translate }}
            </p>
        </div>
    </div>
    <div class="orgApp-reset-pwd-cont-h orgApp-d-flex orgApp-flex-dir-col">
        <mat-dialog-content class="orgApp-change-pwd-dialog-content orgApp-d-flex orgApp-flex-dir-col">
            <form [formGroup]="changePassword" class="orgApp-change-pwd-margin orgApp-d-flex orgApp-flex-dir-col orgApp-justify-c-center">
                <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-change-pwd-div orgApp-gap-12">
                    <mat-form-field floatLabel="always" appearance="outline"
                        class="orgApp-reset-pwd-width orgApp-field-rounded-lg orgApp-input-field-md orgApp-input-field-pwd"
                        [ngClass]="{
                            error:
                                changePassword.get('newPassword')?.hasError('whitespace') ||
                                changePassword.get('newPassword')?.hasError('invalidPassword')
                            }">
                        <mat-label>{{"manage_profile.change_password.label.new_password" | translate }}</mat-label>
                        <input matInput [type]="hideNewPwd ? 'password' : 'text'" id="newPassword" (input)="passwordMatchValidator()"
                            formControlName="newPassword" placeholder="{{'manage_profile.change_password.placeholder.new_password'| translate}}" 
                        />

                        <button mat-icon-button matSuffix class="orgApp-login-password-eye"
                            (click)="togglePasswordVisibility('hideNewPwd')">
                            <svg width="24" height="24">
                                <use [attr.xlink:href]="hideNewPwd ? '#visibility-login-off' : '#visibility-login-on'">
                                </use>
                            </svg>
                        </button>
                        <mat-hint>
                            <b class="orgApp-input-field-pwd-hint">{{
                                "manage_profile.change_password.hint.hint" | translate
                                }}</b>{{ "manage_profile.change_password.hint.hint_msg" | translate }}
                        </mat-hint>
                        <mat-error *ngIf="changePassword.get('newPassword')?.hasError('invalidPassword')">
                            {{ "manage_profile.change_password.error.password_format" | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field floatLabel="always" appearance="outline"
                        class="orgApp-reset-pwd-width orgApp-field-rounded-lg orgApp-input-field-md orgApp-reset-pwd orgApp-no-bottom-input"
                        [ngClass]="{ 'orgApp-error-field':(changePassword.get('confirmPassword')?.touched) && ((changePassword.get('confirmPassword')?.hasError('whitespace')) ||
                                    ((!passwordMatch) && (changePassword.value.confirmPassword))) }">
                        <mat-label>
                            {{
                            "manage_profile.change_password.label.confirm_password"
                            | translate
                            }}</mat-label>
                        <input matInput id="confirmPassword" [type]="hideConfirmPwd ? 'password' : 'text'" (input)="passwordMatchValidator()"
                            formControlName="confirmPassword" placeholder="{{'manage_profile.change_password.placeholder.confirm_password'| translate}}"
                        />
                        <button mat-icon-button matSuffix class="orgApp-login-password-eye"
                            (click)="togglePasswordVisibility('hideConfirmPwd')">
                            <svg width="24" height="24">
                                <use
                                    [attr.xlink:href]="hideConfirmPwd ? '#visibility-login-off' : '#visibility-login-on'">
                                </use>
                            </svg>
                        </button>
                    </mat-form-field>
                </div>
                 @if (changePassword.get('confirmPassword')?.touched){
                    <ng-container>
                        @if(!passwordMatch){
                        <mat-error class="orgApp-rp-custom-error">
                            {{ "manage_profile.change_password.error.password_mismatch" | translate }}
                        </mat-error>
                        }
                    </ng-container>
                }
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="orgApp-d-flex  orgApp-reset-pwd-act-cont">
            <div class="orgApp-reset-pwd-btn-container orgApp-d-flex orgApp-flex-dir-col orgApp-gap-24">
                <button mat-raised-button
                    class="orgApp-reset-pwd-action-btn orgApp-reset-pwd-font orgApp-sign-in-btn orgApp-reset-pwd-width"
                    [disabled]="!changePassword.valid || !passwordMatch" [ngClass]="{
                disable: !changePassword.valid || !passwordMatch
                }" (click)="updatePwd()">
                    {{ "manage_profile.change_password.action.save_btn" | translate }}
                </button>
                <p class="orgApp-text-link orgApp-back-link orgApp-reset-pwd-font orgApp-text-center" (click)="showLogin('login')">
                    <b>{{ "forgot_pwd.action.back_to_sign_in" | translate }}</b>
                </p>
            </div>
        </mat-dialog-actions>
    </div>
</div>